import { buildRequestsReceivedInsightFactory } from './builders/requestsReceived';
import { buildRequestsResponseRatioInsightFactory } from './builders/requestsResponseRatio';
import { buildRequestsStatusInsightFactory } from './builders/requestsStatus';
import { buildRequestsDeclinedInsightFactory } from './builders/requestsDeclined';
import { buildRequestsBusinessUnitInsightFactory } from './builders/requestsBusinessUnit';
import { buildRequestsPriorityInsightFactory } from './builders/requestsPriority';
import { buildRequestsTypeInsightFactory } from './builders/requestsType';
import { buildRequestsInReviewInsightFactory } from './builders/requestsInReview';

import { buildProjectsBusinessUnitInsightFactory } from './builders/projectsBusinessUnit';
import { buildProjectsCreatedInsightFactory } from './builders/projectsCreated';
import { buildProjectsStartedInsightFactory } from './builders/projectsStarted';
import { buildProjectsTargetedToCompleteInsightFactory } from './builders/projectsTargetedToComplete';
import { buildProjectsBusinessUnitDemandInsightFactory } from './builders/projectsBusinessUnitDemand';
import { buildProjectsCompletedInsightFactory } from './builders/projectsCompleted';
import { buildProjectsTargetedToLaunchInsightFactory } from './builders/projectsTargetedToLaunch';
import { buildProjectsCategoryDemandInsightFactory } from './builders/projectsCategoryDemand';
import { buildProjectsProgramDemandInsightFactory } from './builders/projectsProgramDemand';
import { buildProjectsProgramInsightFactory } from './builders/projectsProgram';
import { buildProjectsCategoryInsightFactory } from './builders/projectsCategory';
import { buildProjectsStatusInsightFactory } from './builders/projectsStatus';
import { buildTasksDemandHoursInsightFactory } from './builders/tasksDemandHours';
import { buildTasksStatusInsightFactory } from './builders/tasksStatus';
import { buildUsersCapacityHoursInsightFactory } from './builders/usersCapacityHours';
import { buildUsersAvailableHoursInsightFactory } from './builders/usersAvailableHours';
import { buildUsersTypeInsightFactory } from './builders/usersType';
import { buildCapacityManagementEstimatedVsActualHoursTeamsInsightFactory } from './builders/capacityManagementEstimatedVsActualHoursTeams';
import { buildCapacityManagementEstimatedVsActualHoursUsersInsightFactory } from './builders/capacityManagementEstimatedVsActualHoursUsers';
import { buildEventsTypeInsightFactory } from './builders/eventsType';
import { buildEventsAssignmentInsightFactory } from './builders/eventsAssignment';

import { buildCapacityManagementAllocatedHoursInsightFactory } from './builders/capacityManagementAllocatedHours';
import { buildCapacityManagementActualHoursInsightFactory } from './builders/capacityManagementActualHours';
import { buildCapacityManagementUserTypeInsightFactory } from './builders/capacityManagementUserType';
import { buildCapacityManagementResourceWorkloadOverviewInsightFactory } from './builders/capacityManagementResourceWorkloadOverview';

import { BaseInsightPayload } from './InsightDataPayload';
import {
  InsightChartFactory,
  InsightBuilderOptions,
} from './insightChartFactory';
import { ChartType } from './chartTypes';
import { buildUserUtilizationInsightFactory } from './builders/userUtilization';
import { parseUserUtilizationPayload } from './payloads/userUtilizationPayload';
import { buildTeamUtilizationInsightFactory } from './builders/teamUtilization';
import { parseTeamUtilizationPayload } from './payloads/teamUtilizationPayload';
import { parseJobFunctionUtilizationPayload } from './payloads/jobFunctionUtilizationPayload';
import { buildJobFunctionUtilizationInsightFactory } from './builders/jobFunctionUtilization';

export enum InsightCategory {
  REQUESTS = 'requests',
  PROJECTS = 'projects',
  TASKS = 'tasks',
  USERS = 'users',
  CAPACITY_MANAGEMENT = 'capacity-management',
  EVENTS = 'events-insights',
}

export enum InsightCatalogue {
  // REQUEST INSIGHTS
  INSIGHTS_REQUESTS_RECEIVED = 'insights-requests-received',
  INSIGHTS_REQUESTS_RESPONSE_RATIO = 'insights-requests-response-ratio',
  INSIGHTS_REQUESTS_STATUS = 'insights-requests-status',
  INSIGHTS_REQUESTS_DECLINED = 'insights-requests-declined',
  INSIGHTS_REQUESTS_BUSINESS_UNIT = 'insights-requests-business-unit',
  INSIGHTS_REQUESTS_PRIORITY = 'insights-requests-priority',
  INSIGHTS_REQUESTS_TYPE = 'insights-requests-type',
  INSIGHTS_REQUESTS_IN_REVIEW = 'insights-requests-in-review',
  INSIGHTS_REQUESTS_LIST = 'insights-requests-list',

  // PROJECT INSIGHTS
  INSIGHTS_PROJECTS_CREATED = 'insights-projects-created',
  INSIGHTS_PROJECTS_STARTED = 'insights-projects-started',
  INSIGHTS_PROJECTS_COMPLETED = 'insights-projects-completed',
  INSIGHTS_PROJECTS_TARGETED_TO_COMPLETE = 'insights-projects-targeted-to-complete',
  INSIGHTS_PROJECTS_TARGETED_TO_LAUNCH = 'insights-projects-targeted-to-launch',
  INSIGHTS_PROJECTS_BUSINESS_UNIT_DEMAND = 'insights-projects-business-unit-demand',
  INSIGHTS_PROJECTS_CATEGORY_DEMAND = 'insights-projects-category-demand',
  INSIGHTS_PROJECTS_PROGRAM_DEMAND = 'insights-projects-program-demand',
  INSIGHTS_PROJECTS_PROGRAM = 'insights-projects-program',
  INSIGHTS_PROJECTS_CATEGORY = 'insights-projects-category',
  INSIGHTS_PROJECTS_BUSINESS_UNIT = 'insights-projects-business-unit',
  INSIGHTS_PROJECTS_STATUS = 'insights-projects-status',
  INSIGHTS_PROJECTS_LIST = 'insights-projects-list',

  // TASK INSIGHTS
  INSIGHTS_TASKS_DEMAND_HOURS = 'insights-tasks-demand-hours',
  INSIGHTS_TASKS_STATUS = 'insights-tasks-status',
  INSIGHTS_TASKS_LIST = 'insights-tasks-list',

  // USER INSIGHTS
  INSIGHTS_USERS_CAPACITY_HOURS = 'insights-users-capacity-hours',
  INSIGHTS_USERS_AVAILABLE_HOURS = 'insights-users-available-hours',
  INSIGHTS_USERS_TYPE = 'insights-users-type',
  INSIGHTS_USERS_LIST = 'insights-users-list',

  // CAPACITY MANAGEMENT INSIGHTS
  INSIGHTS_CAPACITY_MANAGEMENT_ALLOCATED_HOURS = 'insights-capacity-management-allocated-hours',
  INSIGHTS_CAPACITY_MANAGEMENT_ACTUAL_HOURS = 'insights-capacity-management-actual-hours',
  INSIGHTS_CAPACITY_MANAGEMENT_USER_TYPE = 'insights-capacity-management-user-type',
  INSIGHTS_CAPACITY_MANAGEMENT_ESTIMATED_VS_ACTUAL_HOURS_JOB_FUNCTIONS = 'insights-capacity-management-estimated-vs-actual-hours-job-functions',
  INSIGHTS_CAPACITY_MANAGEMENT_ESTIMATED_VS_ACTUAL_HOURS_TEAMS = 'insights-capacity-management-estimated-vs-actual-hours-teams',
  INSIGHTS_CAPACITY_MANAGEMENT_ESTIMATED_VS_ACTUAL_HOURS_USERS = 'insights-capacity-management-estimated-vs-actual-hours-users',
  INSIGHTS_CAPACITY_MANAGEMENT_TEAM_UTILIZATION = 'insights-capacity-management-team-utilization',
  INSIGHTS_CAPACITY_MANAGEMENT_JOB_FUNCTION_UTILIZATION = 'insights-capacity-management-job-function-utilization',
  INSIGHTS_CAPACITY_MANAGEMENT_USER_UTILIZATION = 'insights-capacity-management-user-utilization',
  INSIGHTS_CAPACITY_MANAGEMENT_RESOURCE_WORKLOAD_OVERVIEW = 'insights-capacity-management-resource-workload-overview',
  INSIGHTS_CAPACITY_MANAGEMENT_INSIGHTS = 'insights-capacity-management-insights',

  // EVENT INSIGHTS
  INSIGHTS_EVENTS_TYPE = 'insights-events-type',
  INSIGHTS_EVENTS_ASSIGNMENT = 'insights-events-assignment',
  INSIGHTS_EVENTS_FACILITATION_BY_USER = 'insights-events-facilitation-by-user',
  INSIGHTS_EVENTS_FACILITATION_BY_JOB_FUNCTION = 'insights-events-facilitation-by-job-function',
  INSIGHTS_EVENTS_FACILITATION_BY_TEAM = 'insights-events-facilitation-by-team',
  INSIGHTS_EVENTS_LIST = 'insights-events-list',
}

export function isInsightCatalogue(id: unknown): id is InsightCatalogue {
  return (
    typeof id === 'string' &&
    Object.values(InsightCatalogue).includes(id as InsightCatalogue)
  );
}

// Compile-time checked mapping between InsightKeys and InsightCategory
export const INSIGHT_TO_CATEGORY: Record<InsightCatalogue, InsightCategory> = {
  // REQUEST INSIGHTS
  [InsightCatalogue.INSIGHTS_REQUESTS_RECEIVED]: InsightCategory.REQUESTS,
  [InsightCatalogue.INSIGHTS_REQUESTS_RESPONSE_RATIO]: InsightCategory.REQUESTS,
  [InsightCatalogue.INSIGHTS_REQUESTS_STATUS]: InsightCategory.REQUESTS,
  [InsightCatalogue.INSIGHTS_REQUESTS_DECLINED]: InsightCategory.REQUESTS,
  [InsightCatalogue.INSIGHTS_REQUESTS_BUSINESS_UNIT]: InsightCategory.REQUESTS,
  [InsightCatalogue.INSIGHTS_REQUESTS_PRIORITY]: InsightCategory.REQUESTS,
  [InsightCatalogue.INSIGHTS_REQUESTS_TYPE]: InsightCategory.REQUESTS,
  [InsightCatalogue.INSIGHTS_REQUESTS_IN_REVIEW]: InsightCategory.REQUESTS,
  [InsightCatalogue.INSIGHTS_REQUESTS_LIST]: InsightCategory.REQUESTS,

  // PROJECT INSIGHTS
  [InsightCatalogue.INSIGHTS_PROJECTS_CREATED]: InsightCategory.PROJECTS,
  [InsightCatalogue.INSIGHTS_PROJECTS_STARTED]: InsightCategory.PROJECTS,
  [InsightCatalogue.INSIGHTS_PROJECTS_COMPLETED]: InsightCategory.PROJECTS,
  [InsightCatalogue.INSIGHTS_PROJECTS_TARGETED_TO_COMPLETE]:
    InsightCategory.PROJECTS,
  [InsightCatalogue.INSIGHTS_PROJECTS_TARGETED_TO_LAUNCH]:
    InsightCategory.PROJECTS,
  [InsightCatalogue.INSIGHTS_PROJECTS_BUSINESS_UNIT_DEMAND]:
    InsightCategory.PROJECTS,
  [InsightCatalogue.INSIGHTS_PROJECTS_CATEGORY_DEMAND]:
    InsightCategory.PROJECTS,
  [InsightCatalogue.INSIGHTS_PROJECTS_PROGRAM_DEMAND]: InsightCategory.PROJECTS,
  [InsightCatalogue.INSIGHTS_PROJECTS_PROGRAM]: InsightCategory.PROJECTS,
  [InsightCatalogue.INSIGHTS_PROJECTS_CATEGORY]: InsightCategory.PROJECTS,
  [InsightCatalogue.INSIGHTS_PROJECTS_BUSINESS_UNIT]: InsightCategory.PROJECTS,
  [InsightCatalogue.INSIGHTS_PROJECTS_STATUS]: InsightCategory.PROJECTS,
  [InsightCatalogue.INSIGHTS_PROJECTS_LIST]: InsightCategory.PROJECTS,

  // TASK INSIGHTS
  [InsightCatalogue.INSIGHTS_TASKS_DEMAND_HOURS]: InsightCategory.TASKS,
  [InsightCatalogue.INSIGHTS_TASKS_STATUS]: InsightCategory.TASKS,
  [InsightCatalogue.INSIGHTS_TASKS_LIST]: InsightCategory.TASKS,

  // USER INSIGHTS
  [InsightCatalogue.INSIGHTS_USERS_CAPACITY_HOURS]: InsightCategory.USERS,
  [InsightCatalogue.INSIGHTS_USERS_AVAILABLE_HOURS]: InsightCategory.USERS,
  [InsightCatalogue.INSIGHTS_USERS_TYPE]: InsightCategory.USERS,
  [InsightCatalogue.INSIGHTS_USERS_LIST]: InsightCategory.USERS,

  // CAPACITY MANAGEMENT INSIGHTS
  [InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_ALLOCATED_HOURS]:
    InsightCategory.CAPACITY_MANAGEMENT,
  [InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_ACTUAL_HOURS]:
    InsightCategory.CAPACITY_MANAGEMENT,
  [InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_USER_TYPE]:
    InsightCategory.CAPACITY_MANAGEMENT,
  [InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_ESTIMATED_VS_ACTUAL_HOURS_JOB_FUNCTIONS]:
    InsightCategory.CAPACITY_MANAGEMENT,
  [InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_ESTIMATED_VS_ACTUAL_HOURS_TEAMS]:
    InsightCategory.CAPACITY_MANAGEMENT,
  [InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_ESTIMATED_VS_ACTUAL_HOURS_USERS]:
    InsightCategory.CAPACITY_MANAGEMENT,
  [InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_TEAM_UTILIZATION]:
    InsightCategory.CAPACITY_MANAGEMENT,
  [InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_JOB_FUNCTION_UTILIZATION]:
    InsightCategory.CAPACITY_MANAGEMENT,
  [InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_USER_UTILIZATION]:
    InsightCategory.CAPACITY_MANAGEMENT,
  [InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_RESOURCE_WORKLOAD_OVERVIEW]:
    InsightCategory.CAPACITY_MANAGEMENT,
  [InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_INSIGHTS]:
    InsightCategory.CAPACITY_MANAGEMENT,

  // EVENT INSIGHTS
  [InsightCatalogue.INSIGHTS_EVENTS_TYPE]: InsightCategory.EVENTS,
  [InsightCatalogue.INSIGHTS_EVENTS_ASSIGNMENT]: InsightCategory.EVENTS,
  [InsightCatalogue.INSIGHTS_EVENTS_FACILITATION_BY_USER]:
    InsightCategory.EVENTS,
  [InsightCatalogue.INSIGHTS_EVENTS_FACILITATION_BY_JOB_FUNCTION]:
    InsightCategory.EVENTS,
  [InsightCatalogue.INSIGHTS_EVENTS_FACILITATION_BY_TEAM]:
    InsightCategory.EVENTS,
  [InsightCatalogue.INSIGHTS_EVENTS_LIST]: InsightCategory.EVENTS,
} as const;

export const INSIGHT_TO_EXPORT_DATA_PARSER: Partial<
  Record<InsightCatalogue, (payload: BaseInsightPayload) => BaseInsightPayload>
> = {
  [InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_USER_UTILIZATION]:
    parseUserUtilizationPayload,
  [InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_TEAM_UTILIZATION]:
    parseTeamUtilizationPayload,
  [InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_JOB_FUNCTION_UTILIZATION]:
    parseJobFunctionUtilizationPayload,
};

export const INSIGHT_TO_BASE_DRILLDOWN_KEY: Partial<
  Record<InsightCatalogue, string>
> = {
  [InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_USER_UTILIZATION]:
    'user_utilization',
  [InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_TEAM_UTILIZATION]:
    'user_utilization',
  [InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_JOB_FUNCTION_UTILIZATION]:
    'user_utilization',
};

export const INSIGHT_TO_CHART_COMPONENT_FACTORY_BUILDER: Record<
  InsightCatalogue,
  (
    payload: BaseInsightPayload,
    options?: InsightBuilderOptions
  ) => InsightChartFactory
> = {
  // REQUEST INSIGHTS
  [InsightCatalogue.INSIGHTS_REQUESTS_RECEIVED]:
    buildRequestsReceivedInsightFactory,
  [InsightCatalogue.INSIGHTS_REQUESTS_RESPONSE_RATIO]:
    buildRequestsResponseRatioInsightFactory,
  [InsightCatalogue.INSIGHTS_REQUESTS_STATUS]:
    buildRequestsStatusInsightFactory,
  [InsightCatalogue.INSIGHTS_REQUESTS_DECLINED]:
    buildRequestsDeclinedInsightFactory,
  [InsightCatalogue.INSIGHTS_REQUESTS_BUSINESS_UNIT]:
    buildRequestsBusinessUnitInsightFactory,
  [InsightCatalogue.INSIGHTS_REQUESTS_PRIORITY]:
    buildRequestsPriorityInsightFactory,
  [InsightCatalogue.INSIGHTS_REQUESTS_TYPE]: buildRequestsTypeInsightFactory,
  [InsightCatalogue.INSIGHTS_REQUESTS_IN_REVIEW]:
    buildRequestsInReviewInsightFactory,
  [InsightCatalogue.INSIGHTS_REQUESTS_LIST]: () => {
    throw new Error('Not implemented');
  },

  // PROJECT INSIGHTS
  [InsightCatalogue.INSIGHTS_PROJECTS_CREATED]:
    buildProjectsCreatedInsightFactory,
  [InsightCatalogue.INSIGHTS_PROJECTS_STARTED]:
    buildProjectsStartedInsightFactory,
  [InsightCatalogue.INSIGHTS_PROJECTS_COMPLETED]:
    buildProjectsCompletedInsightFactory,
  [InsightCatalogue.INSIGHTS_PROJECTS_TARGETED_TO_COMPLETE]:
    buildProjectsTargetedToCompleteInsightFactory,
  [InsightCatalogue.INSIGHTS_PROJECTS_TARGETED_TO_LAUNCH]:
    buildProjectsTargetedToLaunchInsightFactory,
  [InsightCatalogue.INSIGHTS_PROJECTS_BUSINESS_UNIT_DEMAND]:
    buildProjectsBusinessUnitDemandInsightFactory,
  [InsightCatalogue.INSIGHTS_PROJECTS_CATEGORY_DEMAND]:
    buildProjectsCategoryDemandInsightFactory,
  [InsightCatalogue.INSIGHTS_PROJECTS_PROGRAM_DEMAND]:
    buildProjectsProgramDemandInsightFactory,
  [InsightCatalogue.INSIGHTS_PROJECTS_PROGRAM]:
    buildProjectsProgramInsightFactory,
  [InsightCatalogue.INSIGHTS_PROJECTS_CATEGORY]:
    buildProjectsCategoryInsightFactory,
  [InsightCatalogue.INSIGHTS_PROJECTS_BUSINESS_UNIT]:
    buildProjectsBusinessUnitInsightFactory,
  [InsightCatalogue.INSIGHTS_PROJECTS_STATUS]:
    buildProjectsStatusInsightFactory,
  [InsightCatalogue.INSIGHTS_PROJECTS_LIST]: () => {
    throw new Error('Not implemented');
  },

  // TASK INSIGHTS
  [InsightCatalogue.INSIGHTS_TASKS_DEMAND_HOURS]:
    buildTasksDemandHoursInsightFactory,
  [InsightCatalogue.INSIGHTS_TASKS_STATUS]: buildTasksStatusInsightFactory,
  [InsightCatalogue.INSIGHTS_TASKS_LIST]: () => {
    throw new Error('Not implemented');
  },

  // USER INSIGHTS
  [InsightCatalogue.INSIGHTS_USERS_CAPACITY_HOURS]:
    buildUsersCapacityHoursInsightFactory,
  [InsightCatalogue.INSIGHTS_USERS_AVAILABLE_HOURS]:
    buildUsersAvailableHoursInsightFactory,
  [InsightCatalogue.INSIGHTS_USERS_TYPE]: buildUsersTypeInsightFactory,
  [InsightCatalogue.INSIGHTS_USERS_LIST]: () => {
    throw new Error('Not implemented');
  },

  // CAPACITY MANAGEMENT INSIGHTS
  [InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_ALLOCATED_HOURS]:
    buildCapacityManagementAllocatedHoursInsightFactory,
  [InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_ACTUAL_HOURS]:
    buildCapacityManagementActualHoursInsightFactory,
  [InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_USER_TYPE]:
    buildCapacityManagementUserTypeInsightFactory,
  [InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_ESTIMATED_VS_ACTUAL_HOURS_JOB_FUNCTIONS]:
    () => {
      throw new Error(
        'Not implemented: INSIGHTS_CAPACITY_MANAGEMENT_ESTIMATED_VS_ACTUAL_HOURS_JOB_FUNCTIONS has no builder function'
      );
    },
  [InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_ESTIMATED_VS_ACTUAL_HOURS_TEAMS]:
    buildCapacityManagementEstimatedVsActualHoursTeamsInsightFactory,
  [InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_ESTIMATED_VS_ACTUAL_HOURS_USERS]:
    buildCapacityManagementEstimatedVsActualHoursUsersInsightFactory,
  [InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_TEAM_UTILIZATION]:
    buildTeamUtilizationInsightFactory,
  [InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_JOB_FUNCTION_UTILIZATION]:
    buildJobFunctionUtilizationInsightFactory,
  [InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_USER_UTILIZATION]:
    buildUserUtilizationInsightFactory,
  [InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_RESOURCE_WORKLOAD_OVERVIEW]:
    buildCapacityManagementResourceWorkloadOverviewInsightFactory,
  [InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_INSIGHTS]: () => {
    throw new Error(
      'Not implemented: INSIGHTS_CAPACITY_MANAGEMENT_INSIGHTS has no builder function'
    );
  },

  // EVENT INSIGHTS
  [InsightCatalogue.INSIGHTS_EVENTS_TYPE]: buildEventsTypeInsightFactory,
  [InsightCatalogue.INSIGHTS_EVENTS_ASSIGNMENT]:
    buildEventsAssignmentInsightFactory,
  [InsightCatalogue.INSIGHTS_EVENTS_FACILITATION_BY_USER]: () => {
    throw new Error('Not implemented');
  },
  [InsightCatalogue.INSIGHTS_EVENTS_FACILITATION_BY_JOB_FUNCTION]: () => {
    throw new Error('Not implemented');
  },
  [InsightCatalogue.INSIGHTS_EVENTS_FACILITATION_BY_TEAM]: () => {
    throw new Error('Not implemented');
  },
  [InsightCatalogue.INSIGHTS_EVENTS_LIST]: () => {
    throw new Error('Not implemented');
  },
} as const;

export enum DrillDownCategory {
  REQUESTS = 'requests',
  PROJECTS = 'projects',
  TASKS = 'tasks',
  USERS = 'users',
  CAPACITY_MANAGEMENT = 'capacity-management',
  EVENTS = 'events',
}

// TODO: this will be expanded as we implement more insights
export const INSIGHT_TO_DRILLDOWN_CATEGORY: Partial<
  Record<InsightCatalogue, DrillDownCategory>
> = {
  // REQUEST INSIGHTS - only requests status has drill-down
  [InsightCatalogue.INSIGHTS_REQUESTS_STATUS]: DrillDownCategory.REQUESTS,
  [InsightCatalogue.INSIGHTS_REQUESTS_BUSINESS_UNIT]:
    DrillDownCategory.REQUESTS,
  [InsightCatalogue.INSIGHTS_REQUESTS_RECEIVED]: DrillDownCategory.REQUESTS,
  [InsightCatalogue.INSIGHTS_REQUESTS_RESPONSE_RATIO]:
    DrillDownCategory.REQUESTS,
  [InsightCatalogue.INSIGHTS_REQUESTS_DECLINED]: DrillDownCategory.REQUESTS,
  [InsightCatalogue.INSIGHTS_REQUESTS_PRIORITY]: DrillDownCategory.REQUESTS,
  [InsightCatalogue.INSIGHTS_REQUESTS_TYPE]: DrillDownCategory.REQUESTS,
  [InsightCatalogue.INSIGHTS_REQUESTS_IN_REVIEW]: DrillDownCategory.REQUESTS,

  // PROJECT INSIGHTS - only projects business unit has drill-down
  [InsightCatalogue.INSIGHTS_PROJECTS_BUSINESS_UNIT]:
    DrillDownCategory.PROJECTS,
  [InsightCatalogue.INSIGHTS_PROJECTS_CREATED]: DrillDownCategory.PROJECTS,
  [InsightCatalogue.INSIGHTS_PROJECTS_STARTED]: DrillDownCategory.PROJECTS,
  [InsightCatalogue.INSIGHTS_PROJECTS_COMPLETED]: DrillDownCategory.PROJECTS,
  [InsightCatalogue.INSIGHTS_PROJECTS_TARGETED_TO_COMPLETE]:
    DrillDownCategory.PROJECTS,
  [InsightCatalogue.INSIGHTS_PROJECTS_TARGETED_TO_LAUNCH]:
    DrillDownCategory.PROJECTS,
  [InsightCatalogue.INSIGHTS_PROJECTS_BUSINESS_UNIT_DEMAND]:
    DrillDownCategory.PROJECTS,
  [InsightCatalogue.INSIGHTS_PROJECTS_CATEGORY_DEMAND]:
    DrillDownCategory.PROJECTS,
  [InsightCatalogue.INSIGHTS_PROJECTS_PROGRAM_DEMAND]:
    DrillDownCategory.PROJECTS,
  [InsightCatalogue.INSIGHTS_PROJECTS_PROGRAM]: DrillDownCategory.PROJECTS,
  [InsightCatalogue.INSIGHTS_PROJECTS_CATEGORY]: DrillDownCategory.PROJECTS,
  [InsightCatalogue.INSIGHTS_PROJECTS_STATUS]: DrillDownCategory.PROJECTS,

  // USER INSIGHTS
  [InsightCatalogue.INSIGHTS_USERS_CAPACITY_HOURS]: DrillDownCategory.USERS,
  [InsightCatalogue.INSIGHTS_USERS_AVAILABLE_HOURS]: DrillDownCategory.USERS,
  [InsightCatalogue.INSIGHTS_USERS_TYPE]: DrillDownCategory.USERS,

  // TASK INSIGHTS
  [InsightCatalogue.INSIGHTS_TASKS_DEMAND_HOURS]: DrillDownCategory.TASKS,
  [InsightCatalogue.INSIGHTS_TASKS_STATUS]: DrillDownCategory.TASKS,

  // CAPACITY MANAGEMENT INSIGHTS - only specific ones have drill-down
  [InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_USER_TYPE]:
    DrillDownCategory.CAPACITY_MANAGEMENT,
  [InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_TEAM_UTILIZATION]:
    DrillDownCategory.USERS,
  [InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_USER_UTILIZATION]:
    DrillDownCategory.USERS,
  [InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_JOB_FUNCTION_UTILIZATION]:
    DrillDownCategory.USERS,
  [InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_RESOURCE_WORKLOAD_OVERVIEW]:
    DrillDownCategory.USERS,
  [InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_ACTUAL_HOURS]:
    DrillDownCategory.CAPACITY_MANAGEMENT,
  [InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_ALLOCATED_HOURS]:
    DrillDownCategory.CAPACITY_MANAGEMENT,
};

export const DRILLDOWN_KEY_TO_ENTITY_TYPE: Partial<
  Record<string, DrillDownCategory>
> = {
  task_utilization: DrillDownCategory.CAPACITY_MANAGEMENT,
  event_utilization: DrillDownCategory.EVENTS,
};

export const INSIGHT_TO_CHART_TYPE: Partial<
  Record<InsightCatalogue, ChartType>
> = {
  // REQUEST INSIGHTS
  [InsightCatalogue.INSIGHTS_REQUESTS_RECEIVED]: ChartType.KPI,
  [InsightCatalogue.INSIGHTS_REQUESTS_RESPONSE_RATIO]: ChartType.KPI,
  [InsightCatalogue.INSIGHTS_REQUESTS_STATUS]: ChartType.V_BAR,
  [InsightCatalogue.INSIGHTS_REQUESTS_DECLINED]: ChartType.DONUT,
  [InsightCatalogue.INSIGHTS_REQUESTS_BUSINESS_UNIT]: ChartType.H_BAR_STACK,
  [InsightCatalogue.INSIGHTS_REQUESTS_PRIORITY]: ChartType.H_BAR_STACK,
  [InsightCatalogue.INSIGHTS_REQUESTS_TYPE]: ChartType.H_BAR_STACK,
  [InsightCatalogue.INSIGHTS_REQUESTS_IN_REVIEW]: ChartType.H_BAR,

  // PROJECT INSIGHTS
  [InsightCatalogue.INSIGHTS_PROJECTS_BUSINESS_UNIT]: ChartType.H_BAR_STACK,
  [InsightCatalogue.INSIGHTS_PROJECTS_CREATED]: ChartType.KPI,
  [InsightCatalogue.INSIGHTS_PROJECTS_COMPLETED]: ChartType.KPI,
  [InsightCatalogue.INSIGHTS_PROJECTS_STARTED]: ChartType.KPI,
  [InsightCatalogue.INSIGHTS_PROJECTS_TARGETED_TO_COMPLETE]: ChartType.KPI,

  // USERS
  [InsightCatalogue.INSIGHTS_USERS_AVAILABLE_HOURS]: ChartType.KPI,

  // TASK INSIGHTS
  [InsightCatalogue.INSIGHTS_TASKS_DEMAND_HOURS]: ChartType.KPI,
  [InsightCatalogue.INSIGHTS_TASKS_STATUS]: ChartType.V_BAR,
  [InsightCatalogue.INSIGHTS_PROJECTS_STATUS]: ChartType.V_BAR,
  [InsightCatalogue.INSIGHTS_PROJECTS_PROGRAM]: ChartType.H_BAR_STACK,

  // USER INSIGHTS
  [InsightCatalogue.INSIGHTS_USERS_CAPACITY_HOURS]: ChartType.KPI,

  // CAPACITY MANAGEMENT INSIGHTS
  [InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_ALLOCATED_HOURS]:
    ChartType.KPI,
  [InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_ACTUAL_HOURS]: ChartType.KPI,
  [InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_USER_TYPE]: ChartType.DONUT,
  [InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_TEAM_UTILIZATION]:
    ChartType.H_BAR_STACK,
  [InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_JOB_FUNCTION_UTILIZATION]:
    ChartType.H_BAR_STACK,
  [InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_RESOURCE_WORKLOAD_OVERVIEW]:
    ChartType.LINE_MULTI,
  [InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_USER_UTILIZATION]:
    ChartType.H_BAR_STACK,
};
